import { Box, Button, Icon, Typography, useTheme } from "@outschool/backpack";
import { TeacherVideoModal_TeacherFragment } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { UserHeadshotImage } from "@outschool/ui-components-shared";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { fasPlayCircle } from "../../../icons";
import { DESKTOP_AVATAR_SIZE, MOBILE_AVATAR_SIZE } from "./utils";

export const TutorCard = ({
  leader,
  onClick,
}: {
  leader: TeacherVideoModal_TeacherFragment;
  onClick: () => void;
}) => {
  const isMobile = useIsMobile();
  const { breakpoints } = useTheme();
  const { t } = useTranslation(
    "ui-components-website\\TutorVideoCarousel\\TutorCard"
  );
  const { name } = leader;
  const ariaLabel = name
    ? t("Open video modal for {{name}}", { name })
    : t`Open video modal for tutor`;

  return (
    <Button
      variant="link"
      aria-label={ariaLabel}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        alignItems: "center",
        color: "common.black",
        "&:hover": {
          color: "primary.700",
          textDecoration: "none !important",
          // this highlights UserHeadshotImage and the play button on hover
          "&>div>div": {
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
          },
        },
      }}
      onClick={onClick}
    >
      <Box sx={{ position: "relative" }}>
        <UserHeadshotImage
          user={leader}
          size={isMobile ? MOBILE_AVATAR_SIZE : DESKTOP_AVATAR_SIZE}
          sx={{
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
            border: "2px solid white",
            [breakpoints.up("md")]: { border: "4px solid white" },
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            lineHeight: "1",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
            borderRadius: "50%",
            backgroundColor: "white",
            padding: "2px",
            [breakpoints.up("md")]: { padding: "4px" },
          }}
        >
          <Icon
            icon={fasPlayCircle}
            color="primary"
            size={isMobile ? "medium" : "large"}
          />
        </Box>
      </Box>
      <Typography
        variant="body1"
        sx={{
          display: "block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: isMobile ? MOBILE_AVATAR_SIZE : DESKTOP_AVATAR_SIZE,
          textAlign: "center",
          fontSize: "1em",
        }}
      >
        {leader.name}
      </Typography>
    </Button>
  );
};
